import { LogsService } from '../services/logs.service';

export function logMessage(...args: any) {
    LogsService.log(...args);
}
